const initialState = {
  data: [],
};

const AdditionalFieldTypesReducer = (
  state = initialState,
  action: { type: any; payload: any }) => {
  switch (action.type) {
    case "AdditionalFieldTypes_Storage":
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
};

export default AdditionalFieldTypesReducer;
